import React from "react";
import ContentLoader from "react-content-loader";
import { Color } from "../../enums/Color";

interface Props {
  columnCount: number;   // number of columns
  rowCount?: number;     // optional, default 5
  rowHeight?: number;    // optional, default 40px
  headerHeight?: number; // optional, default 25px
  gap?: number;          // gap between columns, default 10px
}

export const TableLoader: React.FC<Props> = ({
  columnCount,
  rowCount = 5,
  rowHeight = 70,
  headerHeight = 60,
  gap = 10
}) => {
  const columnWidth = `${100 / columnCount}%`;

  return (
    <div style={{ width: "100%", overflowX: "auto", padding:"36px 0 0 0" }}>
      <ContentLoader
        speed={1}
        width="100%"
        height={headerHeight + (rowHeight + gap) * rowCount }
        backgroundColor={Color.LoaderBackground}
        foregroundColor={Color.LoaderForeground}
      >
        {/* Header row */}
        {[...Array(columnCount)].map((_, i) => (
          <rect
            key={`header-${i}`}
            x={`${i * (100 / columnCount)}%`}
            y={0}
            width={`calc(${columnWidth} - ${gap}px)`}
            height={headerHeight - gap}
            rx="4"
            ry="4"
          />
        ))}

        {/* Table rows */}
        {[...Array(rowCount)].map((_, rowIndex) =>
          [...Array(columnCount)].map((_, colIndex) => (
            <rect
              key={`row-${rowIndex}-col-${colIndex}`}
              x={`${colIndex * (100 / columnCount)}%`}
              y={headerHeight + rowIndex * rowHeight}
              width={`calc(${columnWidth} - ${gap}px)`}
              height={rowHeight - gap}
              rx="4"
              ry="4"
            />
          ))
        )}
      </ContentLoader>
    </div>
  );
};
